import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { IconModule } from '@spartacus/storefront'
import { SharedModule } from '../../../shared/shared.module'
import { CreditClaimAttachmentsModalComponent } from './credit-claim-attachments-modal.component'

@NgModule({
  declarations: [CreditClaimAttachmentsModalComponent],
  imports: [CommonModule, SharedModule, IconModule]
})
export class CreditClaimAttachmentsModalModule {}
